export default class BBDO_Streetwiz {
    static initClass() {
        this.$zipcode = null;
        this.$city = null;
        this.$street = null;
    }

    constructor($zipcode, $city, $street) {
        this.$zipcode = $zipcode;
        this.$city = $city;
        this.$street = $street;
        this.init();
    }

    init() {
        const url = window.site.base_url + "/api/";

        this.typehead_city = new Bloodhound({
            name: 'cities',
            remote: {
                url: url + "get_city?city=%CITY",
                replace: (url, uriEncodedQuery) => {
                    url = url.replace('%CITY', this.$city.val());
                    return url;
                },
                filter(results) {
                    return $.map(results, res => ({ value: res }));
                }
            },
            datumTokenizer(d) {
                return Bloodhound.tokenizers.whitespace(d.value);
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            limit: 15
        });

        this.typehead_city.initialize();

        this.$city.typeahead({
            highlight: true,
            hint: false
        }
            , {
                displayKey: 'value',
                source: this.typehead_city.ttAdapter()
            }
        );

        this.typehead_street = new Bloodhound({
            name: 'streets',
            remote: {
                url: url + "get_street?street=%STREET",
                replace: (url, uriEncodedQuery) => {
                    url = url.replace('%STREET', this.$street.val());
                    return url;
                },
                filter(results) {
                    return $.map(results, res => ({ value: res }));
                }
            },
            datumTokenizer(d) {
                return Bloodhound.tokenizers.whitespace(d.value);
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            limit: 15
        });

        this.typehead_street.initialize();

        this.$street.typeahead({
            highlight: true,
            hint: false
        }
            , {
                displayKey: 'value',
                source: this.typehead_street.ttAdapter()
            }
        );

        const $error_street = this.$street.parent().parent().find('.error-message').remove();
        $error_street.insertAfter(this.$street);

        const $error_city = this.$city.parent().parent().find('.error-message').remove();
        return $error_city.insertAfter(this.$city);
    }
}
